import { Component, Input, HostBinding } from '@angular/core';

@Component({
	selector: 'tacho-data-loader',
	templateUrl: './data-loader.component.html',
	styleUrls: ['./data-loader.component.scss']
})
export class DataLoaderComponent {

	@Input() loading: boolean = true;
	@Input() imageSrc: string = '';

	@HostBinding('class.page-mode')
	@Input() pageMode: boolean = true;

}
